import { observer } from 'mobx-react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import Async from 'components/Async';
import EmptyData from 'components/EmptyData';
import Page from 'components/Page';
import store from 'store';

import useModel from '@common/helpers/useModel';
import CertificatesModal, { ICertificatesModel } from '@common/models/Certificates/Certificates';

import CertificateItem from './CertificateItem';
import { CertificatesSectionWrap } from './styled';

function CertificatePage() {
	const { t } = useTranslation();

	const certificatesModal: ICertificatesModel = useModel(
		CertificatesModal,
		{ student_id: store.currentStudentId },
		[store.currentStudentId],
	);

	return (
		<Page title={t('certificates.main')} type="list">
			<Async
				loading={
					certificatesModal?.loading ||
					store.studentProgramsLoading ||
					store.indivStudentProgramsLoading
				}
			>
				{certificatesModal.data.length <= 0 ? (
					<EmptyData title={t('certificates.emptyDataTitle')} />
				) : (
					<CertificatesSectionWrap>
						{certificatesModal.data.map((certificate, key) => (
							<CertificateItem key={key} certificateModel={certificate} />
						))}
					</CertificatesSectionWrap>
				)}
			</Async>
		</Page>
	);
}

export default observer(CertificatePage);
